import { apiFetch } from "./client";
import type { Issue } from "./issues";

export interface Goal {
  id: string;
  companyId: string;
  title: string;
  description: string | null;
  status: string;
  parentId: string | null;
  ownerId: string | null;
  targetDate: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface GoalProgress {
  goalId: string;
  total: number;
  byStatus: Record<string, number>;
  percentComplete: number;
}

export interface GoalMessage {
  id: string;
  goalId: string;
  companyId: string;
  agentId: string | null;
  userId: string | null;
  direction: "agent_to_human" | "human_to_agent";
  messageType: string;
  content: string;
  metadata: Record<string, unknown> | null;
  readAt: string | null;
  createdAt: string;
}

export const goalsApi = {
  list: (companyId: string) => apiFetch<Goal[]>(`/goals?companyId=${companyId}`),
  get: (id: string) => apiFetch<Goal>(`/goals/${id}`),
  create: (data: Record<string, unknown>) =>
    apiFetch<Goal>("/goals", { method: "POST", body: JSON.stringify(data) }),
  update: (id: string, data: Record<string, unknown>) =>
    apiFetch<Goal>(`/goals/${id}`, { method: "PATCH", body: JSON.stringify(data) }),
  delete: (id: string) => apiFetch<void>(`/goals/${id}`, { method: "DELETE" }),
  plan: (id: string, tasks: Array<{ title: string; description?: string; priority?: string; assigneeAgentId?: string | null }>) =>
    apiFetch<Issue[]>(`/goals/${id}/plan`, { method: "POST", body: JSON.stringify({ tasks }) }),
  progress: (id: string) =>
    apiFetch<GoalProgress>(`/goals/${id}/progress`),

  // Goal messages
  listMessages: (goalId: string) =>
    apiFetch<GoalMessage[]>(`/goals/${goalId}/messages`),
  sendMessage: (goalId: string, content: string, messageType?: string) =>
    apiFetch<{ humanMessage: GoalMessage; agentReply: GoalMessage | null }>(`/goals/${goalId}/messages`, {
      method: "POST",
      body: JSON.stringify({ content, messageType }),
    }),
  triggerReview: (goalId: string) =>
    apiFetch<{ success: boolean; messages: Array<{ messageType: string; content: string }> }>(`/goals/${goalId}/review`, {
      method: "POST",
    }),
  markMessagesRead: (goalId: string) =>
    apiFetch<{ success: boolean }>(`/goals/${goalId}/messages/read`, { method: "POST" }),
  unreadCount: (companyId: string) =>
    apiFetch<{ count: number }>(`/goals/messages/unread?companyId=${companyId}`),
};
